import React, { useEffect, useRef, useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import styled from "styled-components";
import { ItemTypes } from "modules/Common/Components/ItemTypes";
import store, { RootState } from "store";
import { useSelector } from "react-redux";
import AssetCalendar from "./AssetCalendar";
import { setHoveredAssetId } from "../DragnDrop/actions";
import EditItemName from "modules/Common/Components/EditItemName";
import {
  addArticlesToEmailInEmailBrowser,
  removeEmailFromEmailBrowserList,
  setDesignUpdate,
  undoCurationFromEmail,
  updateEmailNameForBrowserEmailList,
} from "modules/EmailBrowser/actions";
import DeleteIcon from "assets/img/trashIcon.svg";
import SuccessCheckBlogItem from "modules/Common/Components/SuccessCheckBlogItem";
import { removeOnClickBubble } from "utils";
import { getQueryCampaignId, getQueryEmailId } from "modules/EmailBrowser/utils";
import { useHistory } from "react-router";
import { ALL_ARTICLES_IN_EDITION, SEARCH_ARTICLES, WHN_ARTICLES } from "constants/actionTypes";
import EditItemNameSmall from "modules/Common/Components/EditItemNameSmall";
import { DEFAULT_IMAGE_PLACEHOLDER } from "constants/index";
import { Tooltip } from "antd";

type Props = {
  active: boolean;
  id: string;
  isDraggingOver?: boolean;
  greedy?: boolean;
  data: any;
  onDelete?: any;
  isCurrentEmail?: boolean;
};

const EmailItemCard: React.FC<Props> = (props) => {
  const [isEditingName, setIsEditingName] = useState(false);
  const history = useHistory();
  const { data, id, isCurrentEmail } = props;
  const { recent } = data;
  const [dragEnter, setDragEnter] = useState(false);
  const isDragging = useSelector((state: RootState) => state.dragDrop.isDragging);
  const hoveredAssetId = useSelector((state: RootState) => state.dragDrop.hoveredAssetId);

  const campaignId = getQueryCampaignId();
  const emailId = getQueryEmailId();

  const ref = useRef(null);
  const [{ isOver, didDrop, isOverCurrent }, drop] = useDrop(
    () => ({
      accept: ItemTypes.BOX,
      collect: (monitor) => ({
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: true }),
        didDrop: monitor.didDrop(),
      }),
      drop(item: unknown, monitor) {
        // getting selectedArticles from store on the go from the redux
        let selectedArticles = store.getState().dragDrop.selectedIds;
        addArticlesToEmailInEmailBrowser(
          id,
          selectedArticles.length > 0
            ? selectedArticles.toString()
            : store.getState().dragDrop.draggedItem?.id.toString(),
          campaignId
        );
        setHoveredAssetId(0);
      },
    }),
    [props.data]
  );

  const handleUndo = (e: any) => {
    removeOnClickBubble(e);
    let campaignId = getQueryCampaignId();
    let count = data?.recentlyAddedArticles.split(",").length;
    if (data.articlesCount === count && data.showUndo && data.newlyCreated) {
      removeEmailFromEmailBrowserList(id, campaignId);
    } else {
      undoCurationFromEmail(id, data?.recentlyAddedArticles);
    }
    let ids = data?.recentlyAddedArticles?.split(",");
    store.dispatch({
      type: SEARCH_ARTICLES.UPDATE_UNDO_IS_CURATED,
      payload: ids,
    });
    // check if current email then update the store for curated count as well
    let currentEmailId = getQueryEmailId();
    if (currentEmailId === data?.emailId) {
      store.dispatch({
        type: ALL_ARTICLES_IN_EDITION.UPDATE_CURATED_COUNT,
        payload: -1 * ids.length,
      });
      setDesignUpdate(true);
    }
  };

  drop(ref);
  if (isOver && !didDrop && !dragEnter) {
    setDragEnter(true);
    setHoveredAssetId(id);
  }

  if (!isOver && isDragging && !didDrop && dragEnter) {
    setDragEnter(false);
    setHoveredAssetId(0);
  }

  // Deletes card with relevant id
  const deleteCard = (id: any) => {
    let campaignId = getQueryCampaignId() || data?.campaignId;
    removeEmailFromEmailBrowserList(id, campaignId);
  };

  return (
    <BlogItemTwoWrapper
      hover={isOverCurrent}
      className={`${hoveredAssetId?.toString() === id?.toString() ? "" : hoveredAssetId !== 0 ? "disable-item" : ""
        }`}
    >
      <div ref={ref}>
        <div className={`wrapper ${dragEnter ? "drag-enter" : ""}  ${recent ? "recent" : ""}`}>
          <div
            className="content-div"
            onClick={(e) => {
              removeOnClickBubble(e);
              if (isEditingName) return;
              document.body.style.paddingRight = "0";
              // store.dispatch({ type: ALL_ARTICLES_IN_EDITION.RESET_ALL_DATA });
              let url = `/campaigns/editionedit?email_id=${id}${data?.campaignId ? "&campaign_id=" + data?.campaignId : ""
                }`;
              if (campaignId) {
                window.location.href = window.location.origin + url;
              } else {
                history.push(url);
              }
            }}
          >
            <div className="plus-icon-wrapper">{data?.created_on && <AssetCalendar data={data.created_on} />}</div>
            <div className="blog-image">
              {data?.thumbnails[0] ? (
                <div
                  className="img1 img-bg"
                  style={{
                    backgroundImage: `url(${data?.thumbnails[0] || DEFAULT_IMAGE_PLACEHOLDER})`,
                  }}
                />
              ) : (
                <img
                  className="img1"
                  src={data?.thumbnails[0] || "https://media.xiq.io/static/default_campaign_img.png"}
                  alt="img1"
                />
              )}

              <div className="right-images">
                {data?.previewImage && (
                  <div className="overlayed-image">
                    <SuccessCheckBlogItem imgUrl={data.previewImage} />
                  </div>
                )}
                {data?.thumbnails[1] ? (
                  <div
                    className="img2 img-bg"
                    style={{
                      backgroundImage: `url(${data.thumbnails[1] || DEFAULT_IMAGE_PLACEHOLDER})`,
                    }}
                  />
                ) : (
                  <img
                    className="img2"
                    src={data?.thumbnails[1] || "https://media.xiq.io/static/default_campaign_img.png"}
                    alt="img2"
                  />
                )}

                {data?.thumbnails[2] ? (
                  <div
                    className="img3 img-bg"
                    style={{
                      backgroundImage: `url(${data.thumbnails[2] || DEFAULT_IMAGE_PLACEHOLDER})`,
                    }}
                  />
                ) : (
                  <img
                    className="img3"
                    src={data?.thumbnails[2] || "https://media.xiq.io/static/default_campaign_img.png"}
                    alt="img3"
                  />
                )}
              </div>
            </div>

            {/* <div className="asset-badge">Draft</div> */}
            <Tooltip
              placement="topRight"
              title={isCurrentEmail ? `You can't delete the current email` : undefined}
            >
              <DeleteImage
                src={DeleteIcon}
                alt="delete icon"
                isCurrentEmail={isCurrentEmail}
                className={`delete-email`}
                onClick={(e) => {
                  removeOnClickBubble(e);
                  // reason of adding the following check and not on the onClick handler is
                  // because if the user click on the delete icon if will redirect the page
                  !isCurrentEmail && props?.onDelete().then(() => {
                    deleteCard(id);
                  });
                }}
              />
            </Tooltip>
            <div className="content padding-right-xl padding-left-md">
              <div className={`content-inner-wrapper ${recent ? "recent" : ""}`}>
                {/* <h4 className={`title margin-bottom-xs ${recent ? "recent" : ""}`}>{data.name}</h4> */}
                <EditItemNameSmall
                  itemName={data.name}
                  isSmallScreen={false}
                  useExternalStyleObjects={true}
                  submitHandler={(name) => updateEmailNameForBrowserEmailList(name, id)}
                  setIsEditing={setIsEditingName}
                  textWhite={isOverCurrent || recent}
                />
              </div>
              <div className="desc">
                <span className={`published-time padding-sm ${recent ? "recent" : ""}`}>{data.lastUpdate}</span>|
                <span className={`tags padding-sm ${recent ? "recent" : ""}`}>
                  {data.campaignName ?? "Email without campaign"}
                </span>
              </div>
              <div className={`articles-count ${recent ? "recent" : ""}`} data-qa="qa-article-count">
                <span className={`count ${data?.undone || data?.showUndo ? "articles-red" : ""}`}>
                  {data?.articlesCount}
                </span>
                {data?.articlesCount > 1 ? "Articles" : "Article"}
              </div>
            </div>
            <div
              className={`undo ${data?.showUndo ? "undo-green" : "d-none"} ${recent ? "recent" : ""}`}
              onClick={handleUndo}
            >
              Undo
            </div>
          </div>
        </div>
      </div>
    </BlogItemTwoWrapper>
  );
};
export default React.memo(EmailItemCard);


const DeleteImage = styled.img<{ isCurrentEmail?: boolean }>`
  cursor: ${props => props.isCurrentEmail ? "default !important" : "pointer !important"};
`;

const BlogItemTwoWrapper = styled.div<{ hover?: boolean }>`
  ${(props) =>
    props.hover
      ? `
  animation: blink 0.5s 3; 
  // background-color: #27CE0A !important;
  // border: solid 1px #27CE0A !important;
  color: #fff;
  `
      : ""}
  :hover {
    cursor: pointer;
  }
  &.disable-item {
    opacity: 0.3;
    pointer-events: none;
    background-color: #f7f7f7;
  }
  /* .drag-enter {
    border: solid 3px #27CE0A;
    background-color: rgb(39, 206, 10, 0.34) !important;
  } */
  .wrapper {
    background-color: #f7f7f7;
    border-radius: 10px;
    padding-left: 13px;
    padding-right: 13px;
    padding-top: 6px;
    padding-bottom: 6px;
    position: relative;
    cursor: pointer;
    margin-top: 18px;
    &.recent {
      background-color: #27ce0a;
    }
    ${(props) => (props.hover ? "background-color: #27CE0A;" : "")}
    // min-width: 420px;
    .content-div {
      padding-top: 0.5em;
      padding-bottom: 0.5em;
      padding-left: 0px;
      padding-right: 0px;
      display: flex;
      .asset-badge {
        border: none;
        height: 24px;
        min-width: 44px;
        font-size: 12px;
        font-family: "robotomedium", sans-serif;
        background-color: #f6dede;
        border-radius: 15px;
        color: #c21e1e;
        display: flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        right: 10px;
        @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 9px;
          height: 18px;
          min-width: 30px;
          border-radius: 11px;
        }
      }
      .content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        overflow-wrap: anywhere;
        flex-grow: 1;
        .content-inner-wrapper {
          &.recent {
            color: #fff !important;
          }
          .email-name-box {
            min-width: 100%;
            .edit-margin-top {
              line-height: 22px;
              img {
                margin-bottom: 3px;
              }
            }
            span.type {
              width: calc(100% - 40px);
              min-width: 185px;
              @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
                min-width: 140px;
              }
              .email-name {
                line-height: 22px !important;
              }
            }
            .name-container > div {
              min-width: 275px;
              margin-top: -10px;
              @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
                min-width: 210px;
              }
              input {
                min-width: 100%;
              }
            }
          }
        }
      }
      .delete-email {
        cursor: pointer;
        position: absolute;
        right: 18px;
        top: 40px;
        width: 15px;
        height: 18px;
        @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
          top: 30px;
          right: 15px;
        }
      }
      .desc {
        color: #7e7e7e;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        word-break: break-word;
        @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 9px;
        }
      }
      .plus-icon-wrapper {
        display: flex;
        align-items: center;
        padding-right: 14px;
        cursor: pointer;
      }
      .blog-image {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .blog-image {
        .img1 {
          height: 70px;
          width: 52px;
          border-radius: 6px 0px 0px 6px;
          margin-right: 2px;
          @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
            border-radius: 4px 0px 0px 4px;
            height: 50px;
            width: 36px;
          }
        }
        .img-bg {
          background-position: center center;
          background-size: cover;
          background-repeat: no-repeat;
        }
        .right-images {
          .overlayed-image {
            position: absolute;
            left: 9%;
            top: 22%;
          }
          .img-bg {
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;
          }
          display: flex;
          flex-direction: column;
          .img2 {
            height: 34px;
            width: 39px;
            border-radius: 0px 6px 0px 0px;
            margin-bottom: 2px;
            @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
              border-radius: 0px 4px 0px 0px;
              height: 25px;
              width: 28px;
            }
          }
          .img3 {
            height: 34px;
            width: 39px;
            border-radius: 0px 0px 6px 0px;
            @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
              border-radius: 0px 0px 4px 0px;
              height: 23px;
              width: 28px;
            }
          }
        }
      }
      .title {
        font-family: roboto_slabregular, sans-serif;
        font-size: 18px;
        color: #000000;
        margin: 0;
        margin-bottom: 4px;
        padding: 0;
        font-weight: bold;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-weight: normal;
          font-size: 13px;
        }
        &.recent {
          color: #fff;
        }
      }
      .published-time {
        color: #7e7e7e;
        font-size: 12px;
        font-family: "robotomedium", sans-serif;
        font-weight: 500;
        padding-left: 0px;
        ${(props) => (props.hover ? "color: #fff;" : "")}
        @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 9px;
        }
        &.recent {
          color: #fff;
        }
      }
      .tags {
        color: #27ce0a;
        font-size: 12px;
        font-family: "robotomedium", sans-serif;
        font-weight: 500;
        ${(props) => (props.hover ? "color: #fff;" : "")}
        @media all and (max-width: 1439px), (max-height: 730px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 9px;
        }
        &.recent {
          color: #fff;
        }
      }
      .Blog-menu-icon {
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .Blog-menu-icon img {
        cursor: pointer;
        .ant-popover .ant-popover-content .ant-popover-inner {
          border-radius: 10px;
        }
      }
      .articles-count {
        font-size: 11px;
        font-weight: 500;
        font-family: "Roboto", sans-serif;
        transition-duration: 0.5s;
        letter-spacing: -0.35px;
        line-height: 20px;
        display: flex;
        align-items: baseline;
        float: right;
        color: #27ce0a;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 8px;
          line-height: normal;
        }
        ${(props) => (props.hover ? "color: #fff;" : "")}

        .count {
          font-weight: 700;
          color: #fff;
          background: #27ce0a;
          border-radius: 100%;
          padding: 4px 0px 0 0;
          /* border: 2px solid #ffffff; */
          margin-right: 3px;
          text-align: center;
          min-width: 25px;
          min-height: 25px;
          display: inline-block;
          float: left;
          transition-duration: 0.5s;
          line-height: 19px;
          margin-top: 2px;
          text-align: center;
          ${(props) => (props.hover ? "color: #27CE0A; background-color: #fff;" : "")}
          @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
            font-size: 8px;
            line-height: 10px;
            min-width: 15px;
            min-height: 15px;
            padding: 2px 0px;
          }
        }
        .articles-red {
          color: #fff;
          background-color: #cc0000;
          border: none;
          box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 80%);
        }
        /* .articles-green {
          color: #fff;
          background-color: #cc0000;
          border: none;
          box-shadow: 0px 0px 0px 0px rgb(0 0 0 / 80%);
        } */
        &.recent {
          color: #fff;
          .count {
            background-color: #fff;
            border: none;
            box-shadow: none;
            color: #27ce0a;
          }
        }
      }
      .undo {
        position: absolute;
        right: 10px;
        bottom: 5px;
        color: #27ce0a;
        font-weight: 400;
        font-family: "Roboto Slab";
        transition-duration: 0.5s;
        text-align: right;
        float: right;
        letter-spacing: -0.45px;
        padding: 2px 4px;
        border-radius: 5px;
        border: 1px solid transparent;
        font-size: 18px;
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          font-size: 12px;
        }
        &.undo-green {
          color: #27ce0a;
        }
        &.recent {
          color: #fff;
        }
        :hover {
          cursor: pointer;
        }
      }
    }
  }
  .disabled {
    pointer-events: none;

    /* for "disabled" effect */
    opacity: 0.5;
    background: #ccc;
  }
  .remove-failed {
    /* for "disabled" effect */
    opacity: 1;
    background: #facfcf;
  }
  .active {
    border: solid 3px #27ce0a;
    background-color: #fff !important;
    border-bottom-left-radius: 0px !important;
    border-bottom-right-radius: 0px !important;
  }
  .opacity-0 {
    opacity: 0;
  }
`;
